import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { ReactElement, useEffect } from 'react';

import Job from 'components/Job';

import { API_ROUTES } from 'lib/api-routes';
import { ONBOARDING_FLOW_STATE } from 'lib/consts/flowState';
import { withAuth } from 'lib/hocs/withAuth';
import { useAuth } from 'lib/providers/AuthProvider';
import { apiInstance } from 'lib/utils/axios';

import styles from './Create.module.scss';

const Create = (): ReactElement => {
  const router = useRouter();
  const { onboarding } = router.query;
  const { updateUserApiResponse } = useAuth();

  useEffect(() => {
    if (onboarding) {
      const recruiter = { flow_state: ONBOARDING_FLOW_STATE.COMPLETE };
      apiInstance
        .patch(API_ROUTES.RECRUITER_SIGNUP, {
          recruiter,
        })
        .then((res) => updateUserApiResponse(res.data));
    }
  }, [onboarding]);

  return (
    <>
      <Head>
        <title>Create new | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <section className={styles.Create} data-testid="Create">
        <Job />
      </section>
    </>
  );
};
export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'opportunity.posting',
      ])),
    },
  };
}
const CreateWrapper = withAuth(Create);

export default CreateWrapper;
